import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { Box, Tabs, Separator, Stack, VStack, Text } from '@chakra-ui/react'

import { CurrentCoinInfo } from '@!/User/common/components'
import { CoinHistoriesListItem } from '@!/User/CoinHistories/components'
import { useCoinHistories } from '@!/Hooks'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'

const CoinHistories = () => {
  const [coinHistoriesMutation] = useCoinHistories()
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)

  useEffect(() => {
    coinHistoriesMutation.mutate()
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: 'コイン購入履歴' }])
  }, [])

  const tabStyles = {
    flex: '1',
    p: '6px',
    borderWidth: '1px',
    borderRadius: '7px',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '20px',
    _selected: {
      bg: 'label.white',
    },
  }

  return (
    <Box py="30px">
      <CircularProgressModal isOpen={coinHistoriesMutation.isPending} />
      <ConfirmPopupModal
        text="コイン購入履歴の取得に失敗しました。"
        handlePopup={() => (window.location.href = '/user/coin_histories')}
        isOpen={coinHistoriesMutation.isError}
      />
      {coinHistoriesMutation.isSuccess ? (
        <>
          <CurrentCoinInfo coinCounts={coinHistoriesMutation.data} />
          <VStack color="label.secaondary" fontSize="3xs" fontWeight="300" alignItems="flex-start" m={4}>
            <Text>※ マンガBANGブックスで購入したコインのみご利用頂けます。</Text>
            <Text>※ マンガBANG（アプリ）で購入したコインはご利用頂けません。</Text>
          </VStack>
          <Tabs.Root variant="unstyled" defaultValue="purchase" mt="26px">
            <Tabs.List mx="16px" mb="24px" bg="bg.tertiary" borderColor="bg.tertiary" borderWidth="1px" borderRadius="7px" display="flex">
              <Tabs.Trigger value="purchase" {...tabStyles}>
                購入履歴
              </Tabs.Trigger>
              <Tabs.Trigger value="usage" {...tabStyles}>
                使用履歴
              </Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="purchase" p="0">
              <Separator />
              <Stack separator={<Separator w="100%" />}>
                {coinHistoriesMutation.data.coin_purchase_histories.map((value, index) => (
                  <CoinHistoriesListItem key={`coin-purchase-histories-${index}`} item={value} />
                ))}
              </Stack>
              <Separator />
            </Tabs.Content>
            <Tabs.Content value="usage" p="0">
              <Separator />
              <Stack separator={<Separator w="100%" />}>
                {coinHistoriesMutation.data.coin_use_histories.map((value, index) => (
                  <CoinHistoriesListItem key={`coin-use-histories-${index}`} item={value} />
                ))}
              </Stack>
              <Separator />
            </Tabs.Content>
          </Tabs.Root>
        </>
      ) : null}
    </Box>
  )
}

export default CoinHistories
